/* NEW PORT VELA - V3 product page: colour-driven gallery, hand-turned 360, variants, add to cart */
(function () {
  'use strict';
  var NPV = window.NPV || {}; var P = NPV.product; if (!P) return;
  var root = document.querySelector('[data-pdp]'); if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var L = P.labels;
  // Las traducciones llegan escapadas para HTML ({{ 'x' | t }}): se decodifican una vez para usarlas como texto.
  (function () { var d = document.createElement('textarea'); Object.keys(L).forEach(function (k) { if (typeof L[k] === 'string' && L[k].indexOf('&') >= 0 && !/Note$|Over$/.test(k)) { d.innerHTML = L[k]; L[k] = d.value; } }); })();
  var COLOR = P.colorIndex, SIZE = P.sizeIndex;

  /* ------------------------------------------------------------------
     Media grouping by colour (alt contract): giro 0, modelo 1,
     exterior 2, delantera 3, espalda 4; 3d/detalle excluded. The 360
     already shows front and back, so the flat shots go last.
     ------------------------------------------------------------------ */
  /* Ad visitors (Meta/Instagram link, remembered for the session) land on the on-model photo, like the ad they tapped;
     everyone else keeps the 360 first (Jacobo, 24-sep and 17-oct-2026). */
  var fromAd = (function () {
    try {
      var q = new URLSearchParams(location.search), src = (q.get('utm_source') || '').toLowerCase();
      var hit = q.has('fbclid') || /^(meta|facebook|fb|instagram|ig)$/.test(src);
      if (hit) sessionStorage.setItem('npv-ad', '1');
      return hit || sessionStorage.getItem('npv-ad') === '1';
    } catch (e) { return false; }
  })();
  function rank(alt) {
    var a = (alt || '').toLowerCase();
    if (a.indexOf('giro') !== -1 || a.indexOf('360') !== -1) return fromAd ? 1 : 0;
    if (a.indexOf('modelo') !== -1) return fromAd ? 0 : 1;
    if (a.indexOf('exterior') !== -1) return 2;
    if (a.indexOf('delantera') !== -1) return 3;
    if (a.indexOf('espalda') !== -1) return 4;
    if (a.indexOf('3d') !== -1 || a.indexOf('detalle') !== -1) return 99;
    return 50;
  }
  function label(m) {
    var r = rank(m.alt);
    if (m.kind === 'spin') return L.spin;
    return r === (fromAd ? 0 : 1) ? L.model : r === 2 ? L.outside : r === 3 ? L.front : r === 4 ? L.back : L.photo;
  }
  function mediaForColor(color) {
    var items = P.media.slice();
    if (COLOR >= 0 && color) {
      var key = color.toLowerCase() + ',';
      var hit = items.filter(function (m) { return (m.alt || '').toLowerCase().indexOf(key) !== -1; });
      // The option value can be renamed without touching the alts (Marino vs "Azul, ..."): fall back to the colour word of the variant's own photo.
      if (!hit.length) {
        var fv = P.variants.filter(function (v) { return v.opts[COLOR] === color && v.mediaId; })[0];
        var fm = fv && P.media.filter(function (m) { return m.id === fv.mediaId; })[0];
        var w = fm && (fm.alt || '').split(' \u2014 ').pop().split(',')[0].trim().toLowerCase();
        if (w) hit = items.filter(function (m) { return (m.alt || '').toLowerCase().indexOf(w + ',') !== -1; });
      }
      if (hit.length) items = hit;
    }
    items = items.filter(function (m) { return rank(m.alt) < 90; });
    items.sort(function (a, b) { return rank(a.alt) - rank(b.alt); });
    return items;
  }

  /* ------------------------------------------------------------------
     Gallery: every media node is already in the page; we only choose
     which set is visible and which item is on stage.
     ------------------------------------------------------------------ */
  var stage = $('[data-stage]'), holder = $('[data-stage-items]'), thumbs = $('[data-thumbs]');
  var prevBtn = $('[data-gallery-prev]'), nextBtn = $('[data-gallery-next]'), countEl = $('[data-gallery-count]');
  var nodes = {}; $$('[data-item]', holder).forEach(function (el) { nodes[el.getAttribute('data-media-id')] = el; });
  var current = [], index = 0;

  function spinOf(el) { var s = el && el.querySelector('[data-spin]'); return s ? (s.__spin || new NPV.Spin(s)) : null; }
  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    current.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'thumb'; b.setAttribute('aria-label', label(m) + ' ' + (i + 1));
      b.setAttribute('aria-current', i === index ? 'true' : 'false');
      b.innerHTML = '<img src="' + m.thumb + '" alt="" width="240" height="300" decoding="async">' + (m.kind === 'spin' ? '<span class="thumb__tag">360</span>' : '');
      b.addEventListener('click', function () { show(i); });
      thumbs.appendChild(b);
    });
    thumbs.hidden = current.length < 2;
  }
  function show(i) {
    if (!current.length) return;
    if (i < 0) i = current.length - 1; if (i >= current.length) i = 0;
    index = i;
    var m = current[i], el = nodes[String(m.id)];
    Object.keys(nodes).forEach(function (id) {
      var n = nodes[id]; if (n === el) return;
      if (!n.hidden) { var s = n.querySelector('[data-spin]'); if (s && s.__spin) s.__spin.stop(); }
      n.hidden = true; n.classList.remove('is-on');
    });
    // Phones hide the arrows and a swipe on the 360 turns it, so the stage keeps a next arrow while the 360 is on.
    stage.classList.toggle('is-spin', m.kind === 'spin');
    if (el) {
      el.hidden = false; el.classList.add('is-on');
      var sp = spinOf(el); if (sp) sp.start();
    }
    if (thumbs) Array.prototype.forEach.call(thumbs.children, function (t, k) {
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
      if (k === i) { var l = t.offsetLeft - thumbs.clientWidth / 2 + t.clientWidth / 2; try { thumbs.scrollTo({ left: l, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { thumbs.scrollLeft = l; } }
    });
    if (countEl) countEl.textContent = current.length > 1 ? ((i + 1) + ' / ' + current.length) : '';
    if (prevBtn) prevBtn.disabled = current.length < 2; if (nextBtn) nextBtn.disabled = current.length < 2;
  }
  function renderGallery(color) {
    current = mediaForColor(color);
    if (!current.length) current = P.media.slice(0, 1);
    index = 0;
    renderThumbs();
    show(0);
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

  /* swipe between photos on the stage (the 360 itself turns instead) */
  (function () {
    var sx = 0, sy = 0, on = false;
    // Reset on every press and on pointercancel (a vertical pan cancels it), or a stale start point turns a later 360 drag into a slide change.
    stage.addEventListener('pointerdown', function (e) { on = false; if (e.target.closest('[data-spin]') || e.target.closest('button')) return; on = true; sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointercancel', function () { on = false; });
    stage.addEventListener('pointerup', function (e) { if (!on) return; on = false; if (e.target.closest('[data-spin]')) return; var dx = e.clientX - sx, dy = e.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1)); });
    stage.addEventListener('keydown', function (e) { if (e.target.closest('[data-spin]')) return; if (e.key === 'ArrowRight') show(index + 1); if (e.key === 'ArrowLeft') show(index - 1); });
  })();

  /* ------------------------------------------------------------------
     Variants
     ------------------------------------------------------------------ */
  var idInput = $('[data-variant-id]'), priceEls = $$('[data-price]', document), compareEl = $('[data-compare]'), availEl = $('[data-availability]');
  var atc = $('[data-atc]'), atcText = $('[data-atc-text]'), payEl = $('[data-payment]'), skuEl = $('[data-sku]');
  var valueBtns = $$('[data-opt-value]'), selectedLabels = $$('[data-opt-selected]');
  var form = $('[data-pdp-form]');
  var qtyInput = $('#pdpQty');
  function findVariant(id) { for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === String(id)) return P.variants[i]; return null; }
  function currentOptions() { var v = idInput ? findVariant(idInput.value) : null; if (!v) v = P.variants[0]; return v ? v.opts.slice() : []; }
  function markUnavailable() {
    var cur = currentOptions(), anyPre = false;
    valueBtns.forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-opt-pos'), 10), val = btn.getAttribute('data-opt-value'), ok = false;
      for (var i = 0; i < P.variants.length; i++) {
        var c = P.variants[i]; if (!c.available || c.opts[pos] !== val) continue;
        var match = true;
        for (var j = 0; j < cur.length; j++) { if (j === pos) continue; if (pos === SIZE && j === COLOR && c.opts[j] !== cur[j]) { match = false; break; } if (pos === COLOR) { /* colours stay pickable */ } }
        if (match) { ok = true; break; }
      }
      var pre = false;
      if (ok && pos === SIZE) for (var k = 0; k < P.variants.length; k++) {
        var d = P.variants[k]; if (d.opts[SIZE] !== val || (COLOR >= 0 && d.opts[COLOR] !== cur[COLOR])) continue;
        pre = isOut(d) || (d.managed && d.policy === 'continue' && d.qty - inCart(d) <= 0); break;
      }
      btn.classList.toggle('is-out', !ok);
      btn.classList.toggle('is-pre', pre);
      if (pre) anyPre = true;
      var base = btn.getAttribute('data-label') || val;
      btn.setAttribute('aria-label', !ok ? base + ', ' + L.soldOut : pre ? base + ', ' + L.preShort : base);
    });
    var lg = $('[data-pre-legend]'); if (lg) lg.hidden = !anyPre;
  }
  // Reserva con pago y aviso de reposición.
  // isOut: la variante controla stock, se sigue vendiendo y no queda ninguna unidad.
  // isPre: no quedan unidades para lo que se pide, contando las que ya están en el carrito.
  var cartQty = {};
  function inCart(v) { return (v && cartQty[v.id]) || 0; }
  function isOut(v) { return !!(v && v.managed && v.policy === 'continue' && v.qty <= 0); }
  function wantedQty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
  function left(v) { return v.qty - inCart(v); }
  function isPre(v, extra) {
    if (!v || !v.managed || v.policy !== 'continue') return false;
    return v.qty <= 0 || (extra === undefined ? inCart(v) : extra) + wantedQty() > v.qty;
  }
  function ctaText(v) { return isPre(v) ? L.preCta : v && v.available ? L.add : L.soldOut; }
  function busy() { return !!(atc && atc.classList.contains('is-busy')); }
  // Fecha de entrega: hoy (según la tienda, no el reloj del móvil) + 10 días naturales.
  var preDate = (function () {
    var p = String(P.today || '').split('-'), now = new Date(), dev = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var shop = p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2]) : dev, base = shop > dev ? shop : dev;
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate() + 10);
    var en = String(P.lang || 'es').slice(0, 2) === 'en', dd = ('0' + d.getDate()).slice(-2), mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var long, prop;
    try { long = d.toLocaleDateString(en ? 'en-GB' : 'es-ES', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { long = dd + '/' + mm; }
    try { prop = en ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : dd + '/' + mm + '/' + d.getFullYear(); } catch (e) { prop = dd + '/' + mm + '/' + d.getFullYear(); }
    return { prop: prop, long: long };
  })();
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function thumbFor(v) {
    var m = null; (P.media || []).forEach(function (x) { if (!m && x.id === v.mediaId) m = x; });
    if (!m && COLOR >= 0) (P.media || []).forEach(function (x) { if (!m && x.kind === 'image' && x.alt && x.alt.toLowerCase().indexOf(String(v.opts[COLOR]).toLowerCase()) >= 0) m = x; });
    var u = m && m.thumb ? String(m.thumb) : ''; return u.indexOf('//') === 0 ? 'https:' + u : u;
  }
  function colorName(v) { return (P.colorLabels && P.colorLabels[v]) || v; }
  function notInStock(v) { return !v.available || isOut(v); }
  // Disponibilidad, propiedades de la línea, nota con la fecha y botones, según stock, carrito y cantidad.
  function applyPre(variant, extra) {
    if (!variant) return;
    var pre = isPre(variant, extra), rest = variant.qty - (extra === undefined ? inCart(variant) : extra);
    if (availEl) {
      availEl.classList.remove('is-out', 'is-low', 'is-pre');
      if (isOut(variant) || (variant.managed && variant.policy === 'continue' && rest <= 0)) { availEl.textContent = L.preAvail; availEl.classList.add('is-pre'); }
      else if (!variant.available) { availEl.textContent = P.anyAvailable ? L.out : L.soldOut; availEl.classList.add('is-out'); }
      else if (variant.managed && rest > 0 && rest <= 3) { availEl.textContent = rest === 1 ? L.onlyLeftOne : L.onlyLeft.replace('__N__', String(rest)); availEl.classList.add('is-low'); }
      else availEl.textContent = L.inStock;
    }
    $$('[data-pre-input],[data-pre-date-input]', document).forEach(function (el) { el.disabled = !pre; });
    var di = $('[data-pre-date-input]'); if (di) di.value = preDate.prop;
    var note = $('[data-pre-note]');
    if (note) {
      note.hidden = !pre;
      if (pre) note.innerHTML = (rest > 1 ? L.preOver.replace('__N__', String(rest)) : rest === 1 ? L.preOverOne : L.preNote).replace('__D__', esc(preDate.long));
    }
    // El pago rápido no pasa por el carrito ni lleva las propiedades: fuera en reservas y en las últimas unidades.
    if (payEl) payEl.hidden = !variant.available || pre || (variant.managed && variant.policy === 'continue' && rest - wantedQty() < 3);
    var label = ctaText(variant);
    if (atc && atcText && !atc.classList.contains('is-done') && !busy()) atcText.textContent = label;
    // The sticky button gets the short pre-order label so it stays on one line; the full one is its accessible name.
    var sa = document.querySelector('[data-sticky-add]');
    if (sa) { sa.__label = label; stickyLabel(); syncBar(); }
  }
  /* The bar also shows on arrival, while the buy button is still below the screen (ad visitors land on the gallery).
     There it does not buy: it takes the visitor to the sizes, so nobody orders the preselected size by accident. */
  var barBelow = false;
  function stickyLabel() {
    var sa = document.querySelector('[data-sticky-add]'); if (!sa) return;
    var label = sa.__label || ctaText(idInput ? findVariant(idInput.value) : P.variants[0]);
    if (barBelow && SIZE >= 0 && L.chooseSize) { sa.textContent = L.chooseSize; sa.removeAttribute('aria-label'); return; }
    var pl = label === L.preCta && L.preSticky; sa.textContent = pl || label;
    if (pl) sa.setAttribute('aria-label', label); else sa.removeAttribute('aria-label');
  }
  function refreshCart() {
    var need = P.variants.some(function (v) { return v.managed && v.policy === 'continue' && v.qty > 0; });
    if (!need || !window.fetch || !NPV.routes) return Promise.resolve();
    return fetch(NPV.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cartQty = {}; (c.items || []).forEach(function (i) { cartQty[i.variant_id] = (cartQty[i.variant_id] || 0) + i.quantity; }); })
      .catch(function () {});
  }
  // Aviso: el cliente marca tallas y colores; se apunta a cada combinación que no tenga stock real.
  var notifySel = { size: {}, color: {} }, notifyTouched = { size: false, color: false };
  function optionValues(pos) {
    if (P.optionValues && P.optionValues[pos]) return P.optionValues[pos];
    var seen = {}, out = []; P.variants.forEach(function (c) { var x = c.opts[pos]; if (!seen[x]) { seen[x] = 1; out.push(x); } }); return out;
  }
  function buildChips(key, pos, current) {
    var keep = notifyTouched[key] ? notifySel[key] : null;
    notifySel[key] = {};
    var box = $('[data-notify-box="' + key + '"]'), wrap = $('[data-notify-chips="' + key + '"]');
    if (pos < 0) return;
    var vals = optionValues(pos);
    if (vals.length < 2 || !box || !wrap) { notifySel[key][current] = true; if (box) box.hidden = true; return; }
    box.hidden = false; wrap.innerHTML = '';
    vals.forEach(function (val, k) {
      var id = 'nfy-' + key + '-' + k, lab = document.createElement('label'), cb = document.createElement('input'), sp = document.createElement('span');
      lab.className = 'notify__chip'; lab.setAttribute('for', id);
      cb.type = 'checkbox'; cb.id = id; cb.value = val;
      cb.checked = keep ? keep.hasOwnProperty(val) : val === current;
      if (cb.checked) notifySel[key][val] = true;
      cb.addEventListener('change', function () { notifyTouched[key] = true; if (cb.checked) notifySel[key][val] = true; else delete notifySel[key][val]; var er = $('[data-notify-err]'); if (er) er.hidden = true; });
      sp.textContent = key === 'color' ? colorName(val) : val;
      lab.appendChild(cb); lab.appendChild(sp); wrap.appendChild(lab);
    });
  }
  function buildNotify(variant) {
    var nb = $('[data-notify]'); if (!nb) return;
    var show = notInStock(variant) && !(variant.managed && variant.policy === 'deny'); nb.hidden = !show; if (!show) return;
    var f = nb.querySelector('form'), done = nb.querySelector('[data-notify-done]');
    // Tras apuntarse, al elegir otra variante el formulario vuelve a estar completo.
    if (f && done && !done.hidden) {
      Array.prototype.forEach.call(f.children, function (el) { el.hidden = el === done || el.hasAttribute('data-notify-err'); });
      var b = f.querySelector('button[type=submit]'); if (b) b.disabled = false;
    }
    var tt = nb.querySelector('[data-notify-title]'); if (tt) tt.textContent = tt.getAttribute(isOut(variant) ? 'data-t-pre' : 'data-t-out');
    var er = nb.querySelector('[data-notify-err]'); if (er) er.hidden = true;
    buildChips('size', SIZE, SIZE >= 0 ? variant.opts[SIZE] : null);
    buildChips('color', COLOR, COLOR >= 0 ? variant.opts[COLOR] : null);
  }
  // Combinaciones marcadas; el resto de opciones (si las hay) iguales a la variante elegida.
  function notifyTargets(base) {
    var r = { picked: [], out: [], noSize: SIZE >= 0 && !Object.keys(notifySel.size).length, noColor: COLOR >= 0 && !Object.keys(notifySel.color).length };
    P.variants.forEach(function (c) {
      if (SIZE >= 0 && !notifySel.size.hasOwnProperty(c.opts[SIZE])) return;
      if (COLOR >= 0 && !notifySel.color.hasOwnProperty(c.opts[COLOR])) return;
      for (var j = 0; j < c.opts.length; j++) if (j !== SIZE && j !== COLOR && base && c.opts[j] !== base.opts[j]) return;
      r.picked.push(c); if (notInStock(c)) r.out.push(c);
    });
    return r;
  }
  function comboName(v) { return [COLOR >= 0 ? colorName(v.opts[COLOR]) : '', SIZE >= 0 ? v.opts[SIZE] : ''].filter(Boolean).join(' · ') || P.title; }
  (function () {
    var f = document.getElementById('NpvNotify'); if (!f) return;
    var err = f.querySelector('[data-notify-err]'), done = f.querySelector('[data-notify-done]'), sum = f.querySelector('[data-notify-sum]'), msg = f.querySelector('[data-notify-msg]');
    var mail = f.querySelector('input[type=email]');
    function fail(kind) { err.textContent = err.getAttribute('data-t-' + kind) || err.textContent; err.hidden = false; }
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;
      var base = idInput ? findVariant(idInput.value) : null;
      var tg = notifyTargets(base);
      if (tg.noSize) return fail('size');
      if (tg.noColor) return fail('color');
      if (!tg.out.length) return fail(tg.picked.length ? 'avail' : 'size');
      if (tg.out.length > 12) return fail('many');
      var email = (mail.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { fail('email'); mail.focus(); return; }
      var items = tg.out.map(function (v) {
        return { variant: String(v.id), sku: v.sku, color: COLOR >= 0 ? colorName(v.opts[COLOR]) : '', size: SIZE >= 0 ? v.opts[SIZE] : '', image: thumbFor(v) };
      });
      var btn = f.querySelector('button[type=submit]'); btn.disabled = true;
      fetch(f.action, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, items: items, product: P.title, handle: P.handle, lang: P.lang }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw new Error('x'); return j; }); })
        .then(function (j) {
          if (msg) msg.textContent = msg.getAttribute(j.already ? 'data-t-already' : j.confirmation === false ? 'data-t-noconf' : 'data-t-sent');
          if (sum) sum.textContent = L.notifySum + ' ' + tg.out.map(comboName).join(', ');
          Array.prototype.forEach.call(f.children, function (el) { if (el !== done) el.hidden = true; }); done.hidden = false;
          try { done.focus(); } catch (x) {}
        })
        .catch(function () { fail('net'); btn.disabled = false; });
    });
  })();
  function apply(variant, opts) {
    opts = opts || {};
    if (!variant) return;
    if (idInput) idInput.value = String(variant.id);
    priceEls.forEach(function (el) { el.textContent = variant.priceText; });
    if (compareEl) { compareEl.hidden = !(variant.compare > variant.price); compareEl.textContent = variant.compareText; }
    if (atc && !busy()) { atc.disabled = !variant.available; atc.classList.remove('is-done'); }
    applyPre(variant);
    buildNotify(variant);
    var sa = document.querySelector('[data-sticky-add]');
    if (sa) sa.disabled = !variant.available;
    if (skuEl) skuEl.textContent = variant.sku;
    valueBtns.forEach(function (btn) { var pos = parseInt(btn.getAttribute('data-opt-pos'), 10), on = variant.opts[pos] === btn.getAttribute('data-opt-value'); btn.setAttribute('aria-checked', on ? 'true' : 'false'); btn.tabIndex = on ? 0 : -1; });
    selectedLabels.forEach(function (el) { var i = parseInt(el.getAttribute('data-opt-selected'), 10), v = variant.opts[i] || ''; el.textContent = (i === COLOR && P.colorLabels && P.colorLabels[v]) ? P.colorLabels[v] : v; });
    markUnavailable();
    if (opts.colorChanged) renderGallery(COLOR >= 0 ? variant.opts[COLOR] : null);
    if (window.history && history.replaceState) { try { var u = new URL(location.href); u.searchParams.set('variant', String(variant.id)); history.replaceState({}, '', u.toString()); } catch (e) {} }
  }
  function pick(pos, value) {
    if (busy()) return;
    var want = currentOptions(); var before = want[pos]; want[pos] = value;
    var exact = null, sameColorAvail = null, any = null;
    for (var i = 0; i < P.variants.length; i++) {
      var c = P.variants[i]; if (c.opts[pos] !== value) continue;
      if (!any) any = c;
      var match = true; for (var j = 0; j < want.length; j++) if (c.opts[j] !== want[j]) { match = false; break; }
      if (match) { exact = c; break; }
      if (pos === COLOR && c.available && !sameColorAvail) sameColorAvail = c;
    }
    var chosen = exact || (pos === COLOR ? (sameColorAvail || any) : any);
    if (!chosen) return;
    apply(chosen, { colorChanged: pos === COLOR && before !== value });
  }
  valueBtns.forEach(function (btn) { btn.addEventListener('click', function () { pick(parseInt(btn.getAttribute('data-opt-pos'), 10), btn.getAttribute('data-opt-value')); }); });
  $$('[role="radiogroup"]').forEach(function (group) {
    group.addEventListener('keydown', function (e) {
      var radios = $$('[role="radio"]', group), i = radios.indexOf(document.activeElement);
      if (i < 0) return;
      var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = radios[(i + d + radios.length) % radios.length];
      n.focus(); n.click();
    });
  });

  /* quantity */
  function refreshPre() { var v = idInput ? findVariant(idInput.value) : null; if (v) applyPre(v); }
  $$('[data-qty-step]').forEach(function (b) { b.addEventListener('click', function () { if (!qtyInput || busy()) return; var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10); qtyInput.value = String(Math.max(1, n)); refreshPre(); }); });
  if (qtyInput) { qtyInput.addEventListener('input', refreshPre); qtyInput.addEventListener('change', refreshPre); }

  /* size guide shortcut */
  var guideBtn = $('[data-guide-open]'), guide = $('[data-guide]');
  if (guideBtn && guide) guideBtn.addEventListener('click', function () { guide.open = true; guide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); var s = guide.querySelector('summary'); if (s) s.focus(); });

  /* add to cart */
  if (form && atc) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !NPV.addToCart) return; /* native fallback */
      e.preventDefault();
      if (atc.disabled) return;
      var v = idInput ? findVariant(idInput.value) : null;
      atc.disabled = true; atc.classList.add('is-busy'); if (atcText) atcText.textContent = L.adding;
      if (qtyInput) qtyInput.readOnly = true;
      // Se vuelve a leer el carrito justo antes: la reserva depende de lo que ya haya dentro.
      refreshCart().then(function () { applyPre(v); return NPV.addToCart(form); }).then(function (line) {
        atc.disabled = false; atc.classList.remove('is-busy'); atc.classList.add('is-done'); if (atcText) atcText.textContent = L.added;
        if (qtyInput) qtyInput.readOnly = false;
        NPV.openBag(line);
        refreshCart().then(function () { setTimeout(function () { atc.classList.remove('is-done'); applyPre(findVariant(idInput.value)); markUnavailable(); }, 2200); });
      }).catch(function (err) {
        atc.disabled = false; atc.classList.remove('is-busy'); if (qtyInput) qtyInput.readOnly = false;
        refreshCart().then(function () { applyPre(findVariant(idInput.value)); });
        NPV.toast((err && (err.description || err.message)) || NPV.t.addError);
      });
    });
  }

  /* sticky bar on small screens */
  var bar = $('[data-stickybar]', document), stickyAdd = $('[data-sticky-add]', document), barOn = false;
  // Page padding follows the real bar height, and the Inbox chat bubble is lifted above the bar while it shows (html.chat-lift, npv-v3.css).
  function syncBar() {
    if (!bar) return;
    var h = bar.offsetHeight, de = document.documentElement; /* 0 on desktop, where the bar is display:none */
    if (h) de.style.setProperty('--sticky-h', h + 'px');
    if (barOn && h) { de.style.setProperty('--chat-lift', (h + 10) + 'px'); de.classList.add('chat-lift'); }
    else de.classList.remove('chat-lift');
  }
  if (bar && atc && 'IntersectionObserver' in window) {
    document.body.classList.add('has-stickybar');
    new IntersectionObserver(function (es) {
      var e = es[0], above = !e.isIntersecting && e.boundingClientRect.top < 0, below = !e.isIntersecting && e.boundingClientRect.top > 0;
      var off = above || below;
      barOn = off; barBelow = below; stickyLabel();
      bar.classList.toggle('is-on', off); bar.setAttribute('aria-hidden', off ? 'false' : 'true');
      if (stickyAdd) stickyAdd.tabIndex = off ? 0 : -1;
      syncBar();
    }, { threshold: 0 }).observe(atc);
    window.addEventListener('resize', syncBar);
    if (stickyAdd) stickyAdd.addEventListener('click', function () { if (barBelow && SIZE >= 0) { var so = $('[data-opt="' + SIZE + '"]') || atc; so.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; } if (atc.disabled) { atc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; } if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); });
  }

  /* ---------------- init ---------------- */
  var start = idInput ? findVariant(idInput.value) : P.variants[0];
  // Al llegar (anuncio, enlace corto) no se abre en una talla en reserva si el mismo color tiene otra con stock:
  // el cliente ve primero «Añadir al carrito». Las tallas a 0 siguen en reserva, solo cambia cuál sale marcada.
  if (start && isOut(start)) {
    for (var s = 0; s < P.variants.length; s++) {
      var sv = P.variants[s];
      if (sv.available && !isOut(sv) && (COLOR < 0 || sv.opts[COLOR] === start.opts[COLOR])) { start = sv; break; }
    }
  }
  renderGallery(COLOR >= 0 && start ? start.opts[COLOR] : null);
  if (start) apply(start, {});
  refreshCart().then(function () { var v = idInput ? findVariant(idInput.value) : start; if (v) applyPre(v); markUnavailable(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().then(function () { var v = idInput ? findVariant(idInput.value) : start; if (v) applyPre(v); markUnavailable(); }); });
})();

